// extracted by mini-css-extract-plugin
export var card = "_mc-0";
export var content = "_mc-2";
export var details = "_mc-3";
export var icon = "_mc-1";
export var iconBlue = "_mc-5";
export var iconBrand = "_mc-4";
export var iconGrayBlue = "_mc-6";
export var iconGreen = "_mc-7";
export var iconIndigo = "_mc-8";
export var iconOrange = "_mc-9";
export var iconPurple = "_mc-a";
export var iconRed = "_mc-b";
export var iconWarning = "_mc-c";